<template>
  <v-dialog v-model="audioDialog" persistent width="460">
    <v-card v-if="selectedAudio && selectedLog" class="rec-pop">
      <!-- Header strip -->
      <div class="rec-pop-header">
        <div class="rec-pop-eyebrow">
          <v-icon size="14" color="primary" class="mr-1">mdi-record-rec</v-icon>
          Call recording
        </div>
        <v-btn icon small @click="closeDialog" aria-label="Close">
          <v-icon size="18">mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Body -->
      <div class="rec-pop-body">
        <button
          type="button"
          class="rec-pop-play"
          :class="{ playing: isPlaying }"
          :title="isPlaying ? 'Pause' : 'Play'"
          @click="audio(isPlaying ? 'pause' : 'start')"
        >
          <v-icon size="28" color="white">
            {{ isPlaying ? "mdi-pause" : "mdi-play" }}
          </v-icon>
        </button>

        <div class="rec-pop-meta">
          <div class="rec-pop-title" :title="selectedLog.name">
            {{ selectedLog.name }}
          </div>
          <div
            v-if="selectedLog.accounts && selectedLog.accounts.name"
            class="rec-pop-account"
            :title="selectedLog.accounts.name"
          >
            {{ selectedLog.accounts.name }}
          </div>
          <div class="rec-pop-chips">
            <span class="rec-pop-chip">
              <v-icon size="12" class="mr-1">mdi-phone-outline</v-icon>
              {{ selectedLog.phone }}
            </span>
            <span class="rec-pop-chip rec-pop-chip--muted">
              <v-icon size="12" class="mr-1">mdi-clock-outline</v-icon>
              {{ $moment(selectedLog.calledOn).format("Do MMM, hh:mm a") }}
            </span>
          </div>
        </div>
      </div>

      <!-- Progress bar -->
      <div class="rec-pop-progress">
        <v-progress-linear
          :value="playbackTime"
          height="6"
          color="primary"
          background-color="grey lighten-3"
          rounded
        ></v-progress-linear>
        <div class="rec-pop-times">
          <span>{{ formatAudioTime(currentSeconds) }}</span>
          <span>{{ formatAudioTime(totalSeconds) }}</span>
        </div>
      </div>

      <!-- Actions -->
      <v-card-actions class="rec-pop-actions">
        <v-btn
          v-if="selectedLog.hasOwnProperty('serverResponse')"
          outlined
          color="primary"
          @click="download(selectedLog.serverResponse.RecordingUrl, 'exotel')"
        >
          <v-icon left small>mdi-download</v-icon>
          Download
        </v-btn>
        <v-btn
          v-else-if="selectedLog.defaultDialer == 'Telecmi'"
          outlined
          color="primary"
          @click="download(selectedLog.telecmi.filename, 'telecmi')"
        >
          <v-icon left small>mdi-download</v-icon>
          Download
        </v-btn>
        <v-btn
          v-else-if="selectedLog.defaultDialer == 'Phone Dialer with Rec'"
          outlined
          color="primary"
          @click="download(selectedLog.exotel.recordingUrl, 'exotel-rec')"
        >
          <v-icon left small>mdi-download</v-icon>
          Download
        </v-btn>
        <v-btn
          v-else-if="selectedLog.sipCallRecording"
          outlined
          color="primary"
          @click="
            download(selectedLog.sipCallRecording.mergedUrl, 'sip-merged')
          "
        >
          <v-icon left small>mdi-download</v-icon>
          Download
        </v-btn>
        <v-btn
          v-else
          outlined
          color="primary"
          @click="download(selectedLog.recording.name, 'phone')"
        >
          <v-icon left small>mdi-download</v-icon>
          Download
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Url } from "url";
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters([
      "ENDPOINT",
      "user",
      "dispoList",
      "fieldList",
      "teams",
      "selectedTeam",
      "selectedList",
    ]),
    companyDetails() {
      return this.$store.getters.companyDetails;
    },
  },
  data() {
    return {
      audioDialog: false,
      selectedAudio: null,
      selectedLog: null,
      isPlaying: false,
      playbackTime: 0,
      currentSeconds: 0,
      totalSeconds: 0,
      loader: false,
      telecmiIntegration: false,
    };
  },
  async created() {
    var self = this;
    this.getTelecmiDetails();
  },
  methods: {
    download(src, dialingOpt) {
      if (src != "") {
        if (dialingOpt == "exotel") {
          console.log(src);
          var a = document.createElement("a");

          a.href = src;
          a.setAttribute("download", src.toString());
          a.target = "_blank";
          a.click();
        } else if (dialingOpt == "telecmi") {
          var url = `https://rest.telecmi.com/v2/play?appid=${this.telecmiIntegration.config.appid}&secret=${this.telecmiIntegration.config.secret}&file=${src}`;

          var d = document.createElement("a");

          d.href = url;
          d.setAttribute("download", url.toString());
          d.target = "_blank";
          d.click();
        } else if (dialingOpt == "telecmi-rec") {
          var url2 = `https://rest.telecmi.com/v2/play?appid=2224475&secret=37d75f9c-918a-4b5f-983a-0325eff71221&file=${src}`;

          var d2 = document.createElement("a");

          d2.href = url2;
          d2.setAttribute("download", url2.toString());
          d2.target = "_blank";
          d2.click();
        } else if (dialingOpt == "exotel-rec") {
          var url3 = src;

          console.log("url3", url3);

          var d3 = document.createElement("a");

          d3.href = url3;
          d3.setAttribute("download", url3.toString());
          d3.target = "_blank";
          d3.click();
        } else if (dialingOpt.startsWith("sip-")) {
          // SIP recordings - direct GCS URL download
          console.log("📹 Downloading SIP recording:", src);
          var sipLink = document.createElement("a");
          sipLink.href = src;
          sipLink.setAttribute("download", src.split("/").pop());
          sipLink.target = "_blank";
          sipLink.click();
        } else {
          console.log(src);
          var au = document.createElement("a");

          au.href = `${this.$store.state.ENDPOINT}/storages/get/${src}?access_token=${this.$store.getters.user.token}`;
          au.setAttribute("download", src.toString());
          au.target = "_blank";
          au.click();
        }
      }
    },
    async getTelecmiDetails() {
      var resp = await this.$http.get(
        `${this.ENDPOINT}/integrations?filter[where][companyId]=${this.companyDetails.id}&filter[where][type]=telecmi`,
      );

      if (resp.body.length > 0) this.telecmiIntegration = resp.body[0];
    },
    openDialog(item, dialingOpt) {
      if (dialingOpt == "exotel") {
        (this.selectedAudio = null), (this.selectedLog = null);
        if (typeof item.serverResponse.RecordingUrl != "undefined") {
          var audioExotel = new Audio(`${item.serverResponse.RecordingUrl}`);
          this.selectedAudio = audioExotel;

          console.log("item", item);

          this.selectedLog = item;
          this.audioDialog = true;
        }
      } else if (dialingOpt == "telecmi") {
        var url = `https://rest.telecmi.com/v2/play?appid=${this.telecmiIntegration.config.appid}&secret=${this.telecmiIntegration.config.secret}&file=${item.telecmi.filename}`;

        console.log(url);

        this.selectedAudio = new Audio(url);
        this.selectedLog = item;

        console.log(" this.selectedLog", this.selectedLog);

        this.audioDialog = true;
      } else if (dialingOpt == "exotel-rec") {
        var url2 = item.exotel.recordingUrl;
        console.log(url2);

        this.selectedAudio = new Audio(url2);
        this.selectedLog = item;

        console.log(" this.selectedLog", this.selectedLog);

        this.audioDialog = true;
      } else if (dialingOpt == "sip") {
        // SIP Call Recording - use the merged file URL from sipCallRecording
        if (item.sipCallRecording && item.sipCallRecording.mergedUrl) {
          console.log(
            "📹 Playing SIP recording (merged):",
            item.sipCallRecording.mergedUrl,
          );

          this.selectedAudio = new Audio(item.sipCallRecording.mergedUrl);
          this.selectedLog = item;
          this.audioDialog = true;
        } else {
          console.error("❌ No SIP recording URL found");
        }
      } else {
        (this.selectedAudio = null), (this.selectedLog = null);
        if (typeof item.recording != "undefined") {
          var audioPhone = new Audio(
            `${this.$store.state.ENDPOINT}/storages/get/${item.recording.name}?access_token=${this.$store.getters.user.token}`,
          );
          this.selectedAudio = audioPhone;
          this.selectedLog = item;
          this.audioDialog = true;
        }
      }
    },

    closeDialog() {
      this.selectedAudio.pause();
      // reset item var
      (this.isPlaying = false),
        (this.playbackTime = 0),
        (this.currentSeconds = 0),
        (this.totalSeconds = 0),
        (this.selectedAudio = null),
        (this.selectedLog = null),
        (this.audioDialog = false);
    },

    audio(what) {
      const self = this;
      var audio = self.selectedAudio;

      console.log("audio 123", audio);
      if (typeof audio != "undefined") {
        switch (what) {
          case "start":
            self.isPlaying = true;
            audio.play();

            break;

          case "pause":
            // access audio from ongoing selected track
            audio.pause();
            // reset item var
            self.isPlaying = false;
            // self.playbackTime = 0;
            break;
        }

        audio.ontimeupdate = function(e) {
          self.playbackTime = (audio.currentTime / audio.duration) * 100;
          self.currentSeconds = audio.currentTime || 0;
          self.totalSeconds = audio.duration || 0;
          if (self.playbackTime >= 100 || isNaN(self.playbackTime)) {
            self.isPlaying = false;
            self.playbackTime = 0;
            self.currentSeconds = 0;
          }
        };
      }
    },
    formatAudioTime(secs) {
      if (!secs || !isFinite(secs)) return "0:00";
      const m = Math.floor(secs / 60);
      const s = Math.floor(secs % 60);
      return `${m}:${s.toString().padStart(2, "0")}`;
    },
  },
};
</script>
<style>
.v-input__slot:before {
  border-color: rgb(0 0 0 / 2%) !important;
}
/* Recording popup — theme-aware modern card */
.rec-pop {
  border-radius: 12px !important;
  overflow: hidden;
}
.rec-pop-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  border-bottom: 1px solid #eceff1;
}
.theme--dark .rec-pop-header {
  background: linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%);
  border-bottom-color: rgba(255, 255, 255, 0.08);
}
.rec-pop-eyebrow {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #455a64;
}
.theme--dark .rec-pop-eyebrow {
  color: #b0bec5;
}
.rec-pop-body {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 14px 8px;
}
.rec-pop-play {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2e7d32 0%, #43a047 100%);
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  flex: 0 0 52px;
}
.rec-pop-play:hover {
  transform: scale(1.05);
}
.rec-pop-play:active {
  transform: scale(0.96);
}
.rec-pop-play.playing {
  background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%);
  box-shadow: 0 4px 12px rgba(21, 101, 192, 0.4);
}
.rec-pop-meta {
  min-width: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.rec-pop-title {
  font-size: 15px;
  font-weight: 600;
  color: #1a2027;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.theme--dark .rec-pop-title {
  color: #f5f5f5;
}
.rec-pop-account {
  font-size: 12.5px;
  color: #607d8b;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.theme--dark .rec-pop-account {
  color: #90a4ae;
}
.rec-pop-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}
.rec-pop-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 11px;
  font-size: 11.5px;
  font-weight: 500;
  color: #2e7d32;
  background: rgba(46, 125, 50, 0.1);
  font-variant-numeric: tabular-nums;
}
.rec-pop-chip .v-icon {
  color: inherit !important;
}
.theme--dark .rec-pop-chip {
  color: #81c784;
  background: rgba(129, 199, 132, 0.15);
}
.rec-pop-chip--muted {
  color: #546e7a;
  background: rgba(84, 110, 122, 0.1);
}
.theme--dark .rec-pop-chip--muted {
  color: #b0bec5;
  background: rgba(176, 190, 197, 0.12);
}
.rec-pop-progress {
  padding: 4px 14px 0;
}
.rec-pop-times {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #78909c;
  font-variant-numeric: tabular-nums;
  margin-top: 4px;
}
.theme--dark .rec-pop-times {
  color: #90a4ae;
}
.rec-pop-actions {
  padding: 6px 12px 12px !important;
}
</style>
